import { useMemo } from "react"

import {
  useTemplateDependenciesAvailability,
  type BlockingTemplate,
  type TemplateDependencyResourceKind,
} from "./useTemplateDependenciesAvailability"

export type { TemplateDependencyResourceKind }

type TemplateDependencyAvailability =
  | { status: "idle" }
  | { status: "checking" }
  | { status: "available" }
  | { status: "blocked"; templates: BlockingTemplate[] }
  | { status: "error" }

const NO_RESOURCES: string[] = []

/**
 * Whether one resource can be deleted, or the active Templates that still
 * reference it. The set-wide check backs this, so a single delete and a bulk
 * delete answer the same question the same way.
 */
export function useTemplateDependencyAvailability(
  resourceId: string | null | undefined,
  resourceKind: TemplateDependencyResourceKind,
): TemplateDependencyAvailability {
  const resourceIds = useMemo(
    () => (resourceId ? [resourceId] : NO_RESOURCES),
    [resourceId],
  )
  const availability = useTemplateDependenciesAvailability(
    resourceIds,
    resourceKind,
  )

  if (availability.status !== "ready") {
    return availability
  }

  const [blocked] = availability.blocked
  return blocked
    ? { status: "blocked", templates: blocked.templates }
    : { status: "available" }
}
